<template>
  <div class="wrapper__add-existing-criteria">
    <modal-create-or-update-ultimate-learning-outcome
      v-if="!learningOutcome"
      :learning-unit-id="learningUnitId"
      :show.sync="showModalCreateUltimateLo"
    >
    </modal-create-or-update-ultimate-learning-outcome>

    <BaseModal
      id="ModalAddExistingCriteria"
      :show.sync="$show"
      title="Add existing criterion"
      size="lg"
      @closeModal="hide"
      @openModal="setData"
    >
      <div v-if="!isloading">
        <div v-if="!learningOutcome">
          <p class="mb-0 text-black-50 text__no-lo">No learning outcomes</p>
        </div>

        <div v-else>
          <div>
            <p>
              <b>Competency</b>
            </p>
            <p v-text="learningOutcome.title"></p>
            <div v-if="criterias && criterias.length">
              <b-form-checkbox
                v-for="criteria in criterias"
                :id="`checkbox-criteria_${criteria.id}`"
                :key="criteria.id"
                v-model="selected"
                :name="`checkbox-criteria_${criteria.id}`"
                :value="criteria.id"
                :disabled="checkDisable(criteria)"
                class="ml-4"
              >
                <div>
                  <p class="text__criteria-title" v-text="criteria.title"></p>
                  <p class="text-black-50 text__pass-criteria text-pre-wrap">
                    <b>Pass</b> — {{ criteria.pass_criterion }}
                  </p>
                  <p class="text-black-50 text__not-yet-criteria text-pre-wrap">
                    <b>Not yet</b> — {{ criteria.not_yet_criterion }}
                  </p>
                </div>
              </b-form-checkbox>
            </div>
            <p v-else class="ml-4 text-black-50">No criterion</p>
          </div>

          <div v-if="subLearningOutcomes && subLearningOutcomes.length">
            <p>
              <b>Sub-learning outcome</b>
            </p>
            <div v-for="subLearningOutcome in subLearningOutcomes" :key="subLearningOutcome.id">
              <p v-text="subLearningOutcome.title"></p>
              <span
                v-if="subLearningOutcome.criterion_ids && subLearningOutcome.criterion_ids.length"
              >
                <b-form-checkbox
                  v-for="criterion_id in subLearningOutcome.criterion_ids"
                  :id="`checkbox-criteria_sub_${criteriaSubLearningOutcomes[criterion_id].id}`"
                  :key="criterion_id"
                  v-model="selected"
                  :name="`checkbox-criteria_sub_${criteriaSubLearningOutcomes[criterion_id].id}`"
                  :value="criteriaSubLearningOutcomes[criterion_id].id"
                  :disabled="checkDisable(criteriaSubLearningOutcomes[criterion_id])"
                  class="ml-4"
                >
                  <div>
                    <p v-text="criteriaSubLearningOutcomes[criterion_id].title"></p>
                    <p class="text-black-50">
                      <b>Pass</b> —
                      {{ criteriaSubLearningOutcomes[criterion_id].pass_criterion }}
                    </p>
                    <p class="text-black-50">
                      <b>Not yet</b> —
                      {{ criteriaSubLearningOutcomes[criterion_id].not_yet_criterion }}
                    </p>
                  </div>
                </b-form-checkbox>
              </span>
              <p v-else class="ml-4 text-black-50">No criterion</p>
            </div>
          </div>
        </div>
      </div>

      <template #modal-footer>
        <div v-if="!learningOutcome">
          <b-button
            class="btn btn-first button__create-ultimate-lo"
            variant="primary"
            @click="onCreateLearningOutcome"
          >
            Create an ultimate learning outcome
          </b-button>
        </div>

        <div v-else>
          <b-button
            id="button-cancel"
            variant="link"
            class="btn-link-dark btn__cancel-add-criteria"
            @click="hide()"
          >
            Cancel
          </b-button>
          <b-button
            id="button-add"
            variant="success"
            class="btn__add-criteria"
            :disabled="checkEmptyObj(criteriaSubLearningOutcomes) && criterias.length == 0"
            @click="syncCriteria"
          >
            Add
          </b-button>
        </div>
      </template>
    </BaseModal>
  </div>
</template>

<script>
import { BaseModal } from '@/components/base-components';
import Criteria from '@/models/Criteria';
import LearningOutcome from '@/models/LearningOutcome';
import ModalCreateOrUpdateUltimateLearningOutcome from '@/components/LearningOutcome/ModalCreateOrUpdateUltimateLearningOutcome';

export default {
  components: {
    BaseModal,
    ModalCreateOrUpdateUltimateLearningOutcome
  },

  model: {
    prop: 'selectedCriteria',
    event: 'change'
  },

  props: {
    show: {
      type: [Boolean, Number],
      default: false
    },

    learningUnitId: {
      type: [Number, String],
      required: true
    },

    learningOutcome: {
      type: Object,
      default: () => ({})
    },

    selectedCriteria: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      selected: [],
      isloading: false,
      showModalCreateUltimateLo: false
    };
  },

  computed: {
    $show: {
      get() {
        return this.show;
      },

      set(v) {
        this.$emit('update:show', v);
      }
    },

    criterias() {
      return Criteria.query().whereId(this.learningOutcome.criterion_ids).get();
    },

    subLearningOutcomes() {
      return LearningOutcome.query().whereId(this.learningOutcome.sub_learning_outcome_ids).get();
    },

    criteriaSubLearningOutcomes() {
      let criterion_ids = [],
        criterions = {};
      this.subLearningOutcomes.map((subLearningOutcome) =>
        criterion_ids.push(...subLearningOutcome.criterion_ids)
      );
      Criteria.query()
        .whereId(criterion_ids)
        .get()
        .map((criterion) => (criterions[criterion.id] = criterion));
      return criterions;
    }
  },

  methods: {
    checkEmptyObj(obj) {
      return Object.keys(obj).length === 0;
    },

    checkDisable(criteria) {
      return this.selectedCriteria.filter((id) => id == criteria.id).length ? true : false;
    },

    setData() {
      this.selected = this.selectedCriteria ? [...this.selectedCriteria] : [];
    },

    hide() {
      this.selected = [];

      this.$show = false;
    },

    onCreateLearningOutcome() {
      this.showModalCreateUltimateLo = true;
    },

    syncCriteria() {
      this.$emit('update:selectedCriteria', this.selected);

      this.hide();
    }
  }
};
</script>
